import {computed, ComputedRef} from "vue";
import {useStore} from "@/hooks/useStore";
import {AccountState} from "@/store/modules/AccountModule";

/**
 * A function that provides a reactive computed reference to the account state
 * from the application's global store using the AccountModule.
 *
 * @return {ComputedRef<AccountState>} A computed reference to the account-related state from the store.
 */
export function useAccountState(): ComputedRef<AccountState> {
  const store = useStore();
  return computed(() => store.value.state.AccountModule);
}